import React from 'react'
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <>
      <nav class="navbar navbar-expand-lg bg-body-tertiary">
        <div class="container-fluid">
          <Link class="navbar-brand " to="/">
            <img src='https://cb.arrivalsolutions.in/logo.png' width={125} className='img-fluid' />
          </Link>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto mb-2 mb-lg-0 pe-5">
              <li class="nav-item">
                <Link class="nav-link active" aria-current="page" to="/">Home</Link>
              </li>
              <li class="nav-item">
                <Link class="nav-link" to="/verify-certificate">Verify Certificate</Link>
              </li>

              <li class="nav-item">
                <Link class="nav-link " to="/about-us" >About us</Link>
              </li>

              <li class="nav-item">
                <Link class="nav-link " to="/our-course" >Our Course</Link>
              </li>
            </ul>
            <form class="d-flex me-5" role="search">
              <Link class="btn btn-outline-success navbar-btn px-5" to="/get-started">Get Started</Link>
            </form>
          </div>
        </div>
      </nav>
    </>
  )
}

export default Navbar;